module.exports = __webpack_public_path__ + "img/sales.48bfae1f.png";